import { Megaphone, Mail, Phone } from "lucide-react";
import React, { useContext } from "react";
import { primary } from "../../theme/colors";
import { GlobalContext } from "../../contexts/GlobalContext";
import Btn from "../../components/Btn/Btn";
import Divider from "../Divider/Divider";
import "./CardContactMkt.css";

const CardContactMkt = (props) => {
  const { state } = useContext(GlobalContext);
  const language = state.language || "pt-br";
  const data = require(`../../assets/languages/${language}/press.json`);
  const {
    content,
    contactTitle,
    labelBtn,
    iconBtn,
    contentData,
    contentMkt,
    pressNumber,
    pressMessageNumber,
    urlApi,
  } = data;

  const handleClick = () => {
    const whatsappUrl = `${urlApi}${pressNumber}?text=${encodeURIComponent(pressMessageNumber)}`;
    window.open(whatsappUrl, "_blank");
  };
  return (
    <>
      {props.cardPress ? (
        <div className="information-container">
          <div className="information-content mg-l-10">
            <Divider width={3} height={110} color={primary.primary300} />
            <div className="information-icon mg-l-20 mg-r-20">
              <Megaphone size={60} strokeWidth={1.5} />
            </div>
            <Divider width={1.3} height={110} color={"var(--gray200)"} />
          </div>
          <div className="mg-l-20">
            <span className="title-information">Assessoria de Imprensa</span>
            <span className="text-content">
              Maiores informações com Assessoria de Imprensa, jornalista{" "}
              <strong className="text-bold">Denise de Paiva</strong>.
            </span>
            <div className="information-contact text-content mg-top-10">
              <Mail size={20} />
              <span>denise@braspress.com</span>
            </div>
            <div className="information-contact text-content mg-top-5">
              <Phone size={20} />
              <span>(11) 99941-5535</span>
            </div>
          </div>
        </div>
      ) : (
        <>
          {props.activeContent && <span className="mg-bot-50">{content}</span>}
          <div className="contact  mg-bot-50">
            <div className="contact-app no-hover-effect no-hover-btn">
              <span className="text-primary text-semibold">{contactTitle}</span>
              <Btn
                className="mg-top-20"
                label={labelBtn}
                iconName={iconBtn}
                width={"180px"}
                _function={handleClick}
              />
            </div>
            <Divider isPortrait={true} height={"100px"} margin={"0 56px"} />
            <div className="contact-press">
              <span dangerouslySetInnerHTML={{ __html: contentData }}></span>
            </div>
          </div>
          <div className="contact-mkt d-none">
            <span dangerouslySetInnerHTML={{ __html: contentMkt }}></span>
          </div>
        </>
      )}
    </>
  );
};

export default CardContactMkt;
